import { useExperiencesContext } from '../../experiences/Experiences';
import {
  useBreadcrumbContext,
  useRouterContext,
} from '../../../context/PlpContext';

export const useBreadcrumbData = () => {
  const { breadcrumbs } = useBreadcrumbContext();
  const { query } = useRouterContext();
  const { isSingleColumnLayout } = useExperiencesContext();

  return {
    breadcrumbs,
    query,
    isSingleColumnLayout,
  };
};
